// extracted by mini-css-extract-plugin
export default {"input-password":"InputPassword_input-password__KsrkL","input-password-message":"InputPassword_input-password-message__OV32f"};